import React from "react";

export const MEETING_LINK_LABEL = "Schedule a meet";

export function normalizeMeetingLinkHref(link) {
  const value = String(link || "").trim();
  if (!value) return "";
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
}

export function renderMeetingLink(link, { emptyText = "-", className } = {}) {
  const href = normalizeMeetingLinkHref(link);
  if (!href) return emptyText;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className || "meeting-link-action"}
      style={
        className
          ? undefined
          : {
              color: "#1c74bc",
              textDecoration: "none",
            }
      }
    >
      {MEETING_LINK_LABEL}
    </a>
  );
}
